import type { ComponentType } from "react";
import type { ContentBlock } from "@src/packages/content";

type LinkedContentSheetProps = {
  item: ContentBlock<"medication"> | ContentBlock<"supplement"> | null;
  onClose: () => void;
};

type MedicationSheetProps = {
  item: ContentBlock<"medication"> | null;
  onClose: () => void;
};

type SupplementSheetProps = {
  item: ContentBlock<"supplement"> | null;
  onClose: () => void;
};

export default function LinkedContentSheet({
  item,
  onClose,
}: LinkedContentSheetProps) {
  if (!item) return null;

  if (item.kind === "medication") {
    // Dynamic require avoids a top-level circular import between medication and supplement sheets.
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const MedicationFactsheetSheet = require("./MedicationFactsheetSheet")
      .default as ComponentType<MedicationSheetProps>;
    return <MedicationFactsheetSheet item={item} onClose={onClose} />;
  }

  // Dynamic require avoids a top-level circular import between medication and supplement sheets.
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const SupplementDetailSheet = require("./SupplementDetailSheet")
    .default as ComponentType<SupplementSheetProps>;
  return <SupplementDetailSheet item={item} onClose={onClose} />;
}
